<template>
    <div class="cbfx">
        <img src="../../assets/images/cbfx.png" alt="">
    </div>
</template>

<script>
    export default {
        name: "UndertakingAnalysis"
    }
</script>

<style scoped>

</style>
